export const MEDICINE_SEARCH_LIMIT = 20;
export const MEDICINE_SEARCH_DEBOUNCE_MS = 300;
export const MEDICINE_SEARCH_MIN_LENGTH = 2;

function asText(value) {
  return String(value || '').trim();
}

/**
 * Normalize GET /search_medicines/ payload into typeahead options.
 * Accepts an already-unwrapped array or a leftover { data | items } envelope.
 */
export function mapMedicineSearchRows(rows) {
  const list = Array.isArray(rows)
    ? rows
    : (Array.isArray(rows?.data) ? rows.data : (Array.isArray(rows?.items) ? rows.items : []));

  return list
    .filter((row) => row && typeof row === 'object')
    .map((row) => ({
      id: asText(row.id ?? row.conceptId ?? row.term),
      term: asText(row.term || row.conceptFsn),
      generic_name: asText(row.generic_name),
      manufacturer_name: asText(row.manufacturer_name),
    }))
    .filter((row) => row.term)
    .slice(0, MEDICINE_SEARCH_LIMIT);
}

export function medicineOptionLabel(option) {
  if (!option) return '';
  return typeof option === 'string' ? option : option.term || '';
}

export function medicineOptionKey(option) {
  return `${option?.id || ''}::${option?.term || ''}`;
}
